import { render, staticRenderFns } from "./ContentSectionsSelector.vue?vue&type=template&id=9580ce1c&"
import script from "./ContentSectionsSelector.vue?vue&type=script&lang=js&"
export * from "./ContentSectionsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports